import {
  AssetMap,
  TopicMap,
  DealMap,
  DealAssetMap,
  SaleMap,
} from "web/components"
import SaleAssetAssetMap from "../Map/SaleAssetMap"
import { useObjectList } from "web/hooks/data"

export default function MapView({
  subjectType,
  subjectId,
  parentSubjectType,
  parentSubjectId,
  searchQuery,
  topic,
  view,
  url,
  selectedIds = [],
  onSelectionChanged,
  onItemClick,
  isSplitView,
  page = 1,
}) {
  const { detail } = useObjectList({
    subjectType,
    subjectId,
    parentSubjectType,
    parentSubjectId,
    searchQuery,
    topic: topic?.id,
    view,
    url,
    page,
    enableLocationIndex: true,
    includeLocationOrdinals: isSplitView,
    swrOptions: { suspense: false },
  })

  const isLoading = detail.isLoading

  const data = detail.map((datum) => ({
    ...datum,
    selected: selectedIds.includes(datum.id),
  }))

  const hasTopic = !!topic

  if (hasTopic) {
    return (
      <TopicMap
        subjectType={subjectType}
        topic={topic}
        topicRecords={data}
        onItemClick={onItemClick}
        onSelectionChanged={onSelectionChanged}
        isLoading={isLoading}
        showOrdinals={isSplitView}
      />
    )
  }

  switch (subjectType) {
    case "asset":
      return (
        <AssetMap
          assets={data}
          onSelectionChanged={onSelectionChanged}
          isLoading={isLoading}
          showOrdinals={isSplitView}
        />
      )
    case "deal_asset":
      return (
        <DealAssetMap
          dealAssets={data}
          onSelectionChanged={onSelectionChanged}
          isLoading={isLoading}
          showOrdinals={isSplitView}
        />
      )
    case "deal":
      return (
        <DealMap
          deals={data}
          onSelectionChanged={onSelectionChanged}
          isLoading={isLoading}
          showOrdinals={isSplitView}
        />
      )
    case "sale":
      return (
        <SaleMap
          sales={data}
          onSelectionChanged={onSelectionChanged}
          isLoading={isLoading}
          showOrdinals={isSplitView}
        />
      )
    case "sale_asset":
      return (
        <SaleAssetAssetMap
          saleAssets={data}
          onSelectionChanged={onSelectionChanged}
          isLoading={isLoading}
          showOrdinals={isSplitView}
        />
      )
    default:
      return null
  }
}
